import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';
import { OTP, Typography } from 'mobily-ui-library/lib';

import HeaderNavigation from '../../components/HeaderNavigation/HeaderNavigation';
import { resendOtp, validateOTP, postProductOrder, postInitiatePayment, captureData, validateCaptureData, completeProductOrderApi } from '../../api/api';

import './FTTHOTP.scss';

const win: any = window;
const serverURL = win['base_portal_url'];
const errorPage = win['errorPageURL'];

function FTTHOTP() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, smsSentTo, refId, shoppingCart, lang, requestFlow } = state;
    const { t } = useTranslation();

    const [timer, setTimer] = useState(120);
    const [attempt, setAttempt] = useState(0);
    const [otpValue, setotpValue] = useState('');
    const [OTPError, setOTPError] = useState('');

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: false });
    }, [])

    useEffect(() => {
        let countdown: any;
        const countdownFunction = () => {
            countdown = setInterval(() => {
                setTimer(prevTimer => {
                    if (prevTimer > 0) {
                        return prevTimer - 1;
                    } else {
                        clearInterval(countdown);
                        return 0;
                    }
                });
            }, 1000);
        }
        countdownFunction();

        return () => clearInterval(countdown);
    }, [timer]);

    const formatTime = (time: any) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleOTPChange = (otp: any) => {
        setotpValue(otp);

        if (otp.length === 4) {
            dispatch({ type: "SET_LOADER", payload: true });
            validateOTPAPI(otp);
        }
    }

    const validateOTPAPI = (otp: any) => {
        setOTPError('')
        const data = {
            "operation": "VALIDATE_OTP",
            "extraInfo": [
                {
                    "key": "REF_ID",
                    "value": refId
                },
                {
                    "key": "OTP",
                    "value": otp
                }
            ]
        }

        validateOTP(data)
            .then(async (res: any) => {
                if (res.status === 204) {
                    try {
                        setotpValue("");
                        if (requestFlow === 'installation') {
                            const initiatePaymentReq = {
                                version: "v2",
                                operation: "INITIATE",
                                paymentProcessor: "MPGS",
                                language: lang,
                                "extraInfo": [
                                    {
                                        "key": "SHOPPING_CART_ID",
                                        "value": shoppingCart?.context?.shoppingCart?.id
                                    }
                                ]
                            }

                            const initiatePaymentRes = await postInitiatePayment(initiatePaymentReq);
                            if (initiatePaymentRes.status === 200 && initiatePaymentRes?.data?.status?.statusCode === "CEM_0000") {
                                const sections = shoppingCart?.sections;
                                sections[0].steps[4].fields = [{
                                    name: 'paymentReferenceId',
                                    value: initiatePaymentRes.data.data.paymentReferenceId ?? ''
                                }]
                                const captureDataRequest = {
                                    ...shoppingCart
                                }
                                dispatch({ type: 'UPDATE_SHOPPING_CART', payload: captureDataRequest })
                                await captureData(captureDataRequest)

                                const { sections: _, ...dataForValidation } = shoppingCart;
                                const validateRequest = dataForValidation;
                                if (validateRequest.context && validateRequest.context.sections) {
                                    delete validateRequest.context.sections;
                                }

                                await validateCaptureData(validateRequest)
                                await completeProductOrder()
                            } else {
                                window.location.href = serverURL + errorPage;
                            }
                        } else {
                            await getPostProductApiCall()
                        }
                    } catch (err: any) {
                        console.log(err, 'error')
                        window.location.href = win['base_portal_url'] + win['errorPageURL'];
                    }
                } else if (res.status === 260) {
                    const sourceCode = res?.data?.status?.sourceCode;
                    dispatch({ type: "SET_LOADER", payload: false });
                    if (sourceCode === 'MAPI-260-2') {
                        setOTPError(t(`The_code_you_entered_is_incorrect`));
                    } else if (sourceCode === 'MAPI-260-3') {
                        setOTPError(t('This_code_has_now_expired'));
                    } else if (sourceCode === 'MAPI-260-4') {
                        setOTPError(t('You_exceeded_the_maximum_amount_of_OTP_entries'));
                    } else {
                        window.location.href = serverURL + errorPage;
                    }
                } else {
                    window.location.href = serverURL + errorPage;
                }
            }).catch((e) => {
                console.log(e)
                dispatch({ type: "SET_LOADER", payload: false });
                window.location.href = serverURL + errorPage;
            })
    }

    const getPostProductApiCall = () => {
        const id = shoppingCart?.context?.shoppingCart?.id;
        dispatch({ type: "SET_LOADER", payload: true });

        const req = {
            "shoppingCartId": id,
            "otpReferenceId": refId
        }

        postProductOrder(req)
            .then((response) => {
                dispatch({ type: 'UPDATE_POST_PRODUCT_RESPONSE', payload: response?.data })
                if (response.status === 200 && response?.data?.status?.statusCode === 'CEM_0000') {
                    dispatch({ type: "UPDATE_PAGE", payload: 'success' });
                    dispatch({ type: "UPDATE_ORDER_REQUEST_DATA", payload: response?.data?.data });
                    dispatch({ type: "SET_LOADER", payload: false });
                } else if (['E0000101', 'E0000102'].includes(response?.data?.status?.subErrorCode)) {
                    dispatch({ type: "UPDATE_POPUP", payload: response.data.status.subErrorCode === 'E0000101' ? 'notregistered' : 'existingReq' });
                    dispatch({ type: "SET_LOADER", payload: false });
                } else {
                    dispatch({ type: "UPDATE_POPUP", payload: 'somethingWrong' });
                    dispatch({ type: "SET_LOADER", payload: false });
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage;
            })
    }

    const completeProductOrder = () => {
        const id = shoppingCart?.context?.shoppingCart?.id;
        dispatch({ type: "SET_LOADER", payload: true });

        const req = {
            "shoppingCartId": id
        }

        completeProductOrderApi(req)
            .then((response) => {
                dispatch({ type: 'UPDATE_POST_PRODUCT_RESPONSE', payload: response?.data })
                if (response.status === 200 && response?.data?.status?.statusCode === 'CEM_0000') {
                    dispatch({ type: "UPDATE_PAGE", payload: 'success' });
                    dispatch({ type: "UPDATE_ORDER_REQUEST_DATA", payload: response?.data?.data });
                    dispatch({ type: "SET_LOADER", payload: false });
                } else if (['E0000101', 'E0000102'].includes(response?.data?.status?.subErrorCode)) {
                    dispatch({ type: "UPDATE_POPUP", payload: response.data.status.subErrorCode === 'E0000101' ? 'notregistered' : 'existingReq' });
                    dispatch({ type: "SET_LOADER", payload: false });
                } else {
                    dispatch({ type: "UPDATE_POPUP", payload: 'somethingWrong' });
                    dispatch({ type: "SET_LOADER", payload: false });
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage;
            })
    }

    const handleResend = () => {
        setTimer(120);
        setOTPError('');
        setAttempt(prev => prev + 1);
        dispatch({ type: "SET_LOADER", payload: true });
        const data = {
            "operation": "RESEND_OTP",
            "extraInfo": [
                {
                    "key": "REF_ID",
                    "value": refId
                }
            ]
        }

        resendOtp(data).then((res: any) => {
            dispatch({ type: "SET_LOADER", payload: false });
            if (res.status === 204) {
                setotpValue("");
            } else if (res.status === 260) {
                const sourceCode = res?.data?.status?.sourceCode;
                dispatch({ type: "SET_LOADER", payload: false });
                if (sourceCode === 'MAPI-260-1') {
                    setOTPError(t(`You_exceeded_the_maximum_amount_of_requests`));
                } else {
                    window.location.href = serverURL + errorPage;
                }
            } else {
                window.location.href = serverURL + errorPage;
            }
        }).catch(err => {
            window.location.href = serverURL + errorPage;
        });
    }

    const handleBackArrow = () => {
        dispatch({ type: 'UPDATE_POPUP', payload: 'discard' })
    }

    return (
        <div className='FTTH__OTPContainer'>
            <HeaderNavigation
                rtl={rtl}
                percent={100}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
            />
            <div className='SL__headerText'>
                <Typography rtl={rtl} id="verify-heading" className='SL__heading'>{t('Verify_heading')}</Typography>
                <Typography rtl={rtl} id="verify-Subheading" className='SL__subHeading'>
                    {t('Verify_Subheading')}
                    <div className='Verify__Msisdn'>{smsSentTo}.</div>
                    <div>{t('Verify_ToContinue')}</div>
                </Typography>
            </div>

            <div className='Verify__OTP'>
                <OTP id="otp-input" rtl={rtl} numInputs={4} onChange={handleOTPChange} value={otpValue} />
                {OTPError && (
                    <Typography className='Verify__otpError' rtl={rtl}>
                        {OTPError}
                    </Typography>)}
                {attempt < 4 && (timer > 0 ? (
                    <Typography id="resend-code" rtl={rtl} className='Verify__timer'>
                        {t('Verify_ResendNewCode')} <span>{formatTime(timer)}</span>
                    </Typography>
                ) : (
                    <Typography className='Verify__Resend' rtl={rtl}>
                        {t("Didnt_receive_the_code")}
                        <span id='resend-otp' className='Verify__sendAgain' onClick={handleResend}>
                            {t("Send_again")}
                        </span>
                    </Typography>
                ))}
            </div>
        </div>
    )
}

export default FTTHOTP